module.exports = __webpack_public_path__ + "images/waaijenberg_small32ebc4d6152bf3f0a6bd26e95689d36e.png";